<template>
  <div class="CalculatedTwoBox">
    <van-popup
      v-model="calCulatedTwowShow"
      closeable
      position="bottom"
      :style="{ height: '350px' }"
      @closed="closedFc"
    >
      <calculated-header
        text="可贷多少资金，只差最后一步哦！"
      ></calculated-header>
      <van-cell-group class="mt8">
        <valid-van-field
          v-model="phone"
          label="您的手机号"
          maxlength="11"
          type="number"
        />
        <valid-van-field
          v-model="captchas"
          label="短信验证码"
          placeholder="请输入验证码"
          ref="captcha"
          maxlength="6"
          type="number"
        >
          <button
            slot="button"
            class="buttonStyle"
            :disabled="disabled"
            @click="sendcode"
          >
            {{ messageButton }}
          </button>
        </valid-van-field>
        <div style="display:none">
          <valid-van-field></valid-van-field>
        </div>
        <div class="setOf">
          <div class="immediatelyCheck" @click="sumit">立即查看</div>
        </div>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import { Field, Toast } from 'vant';
import ValidHoc from '@/components/valid';
import { checkPhone } from '@/utils';
import bus from '../utils/bus';
import CalculatedHeader from './CalculatedHeader.vue';

const ValidVanField = ValidHoc(Field);
export default {
  name: 'CalculatedTwo',
  components: {
    ValidVanField,
    CalculatedHeader,
  },
  props: ['moneyFlag'],
  data() {
    return {
      disabled: false,
      messageButton: '获取验证码',
      time: 0,
      show: false,
      phone: '',
      captchas: '',
      calCulatedTwowShow: false,
    };
  },
  mounted() {
    bus.$on('changeCalculatedTwoShow', (falg) => {
      this.calCulatedTwowShow = falg;
    });
  },
  methods: {
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        // eslint-disable-next-line no-plusplus
        this.time--;
        this.messageButton = `${this.time}s后获取`;
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.messageButton = '获取验证码';
        this.disabled = false;
      }
    },
    sendcode() {
      if (checkPhone(this.phone)) {
        this.disabled = true;
        this.$api.CheckAmount.getSms({
          phone: this.phone,
          type: '8',
        })
          .then((res) => {
            if (!res.success) {
              Toast({
                message: res.returnMessage,
                forbidClick: true, // 背景不可点击
              });
              this.disabled = false;
            } else {
              this.time = 60;
              this.timer();
            }

            console.log(res);
          })
          .catch((e) => {
            console.log(e);
            this.disabled = false;
          });
      }
    },
    setClass() {
      if (this.disabled === true) {
        return 'buttonDe';
      }
      return 'buttonStyle';
    },
    closedFc() {
      // 关闭后直接取消
      this.phone = '';
      this.captchas = '';
      this.time = 0;
      this.disabled = false;
      this.messageButton = '获取验证码';
    },
    sumit() {
      if (this.captchas.length !== 6) {
        Toast({
          message: '请填写有效的短信验证码',
        });
        return;
      }
      if (checkPhone(this.phone)) {
        this.getData();
      }
    },
    getData() {
      bus.$emit('calculateTwoGetData', {
        phone: this.phone,
        captcha: this.captchas,
        customerSource: 1,
        activityType: 1,
      });
    },
  },
};
</script>
<style>
.bgColor {
  background: #f8f8f9;
}
.van-button--small {
  min-width: 60px;
  height: 30px;
  padding: 0 8px;
  color: #f65846;
  font-size: 12px;
  line-height: 28px;
  background-color: #fff;
}
.buttonDe {
  margin: 0; /* 2 */
  color: #ccc;
  font-size: 14px;
  outline: none;
}
.buttonStyle {
  margin: 0;
  padding: 0;
  color: #f65846;
  font-size: 14px;
  background: #fff;
  border: 1px solid transparent;
  outline: none;
}
.setOf {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.immediatelyCheck {
  width: 345px;
  height: 45px;
  background: #ff6800;
  border-radius: 8px;
  border-radius: 8px;
  color: #ffffff;
  line-height: 45px;
  text-align: center;
  font-size: 17px;
  font-family: PingFangSC-Semibold;
  margin-top: 40px;
}
.loadingBox {
  position: fixed;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* height: 100%; */
}
</style>
